import arrow3 from "../../images/arrow-3.svg"
import arrow4 from "../../images/arrow-4.svg"
import arrow5 from "../../images/arrow-5.svg"
import arrow6 from "../../images/arrow-6.svg"
import bookopus from "../../images/bookopus.png"
import hardwareWebsite from "../../images/hardware_website.png"
import graphIt from "../../images/graph_it.png"
import "./projects.css"

function Project({ project, gradient, imgOnLeft }) {
    const descriptionComponents = project.description.map((text, idx) => <p key={idx}>{text}</p>);

    const gradientStyle = {
        background: gradient,
        WebkitBackgroundClip: "text",
        WebkitTextFillColor: "transparent",
        backgroundClip: "text",
        textFillColor: "transparent"
    }

    return imgOnLeft ? (
        <section className="project">
            <img className="project-img" src={project.img} alt={project.title + " image"} />
            <div className="project-main">
                <h3 style={gradientStyle} className="project-title">{project.title}</h3>
                <p className="project-tech-stack"><span style={gradientStyle}>Tech Stack: </span>{project.techStack}</p>
                <div className="project-desc">{descriptionComponents}</div>
            </div>
        </section>
    ) : (
        <section className="project reverse">
            <div className="project-main">
                <h3 style={gradientStyle} className="project-title">{project.title}</h3>
                <p className="project-tech-stack"><span style={gradientStyle}>Tech Stack: </span>{project.techStack}</p>
                <div className="project-desc">{descriptionComponents}</div>
            </div>
            <img className="project-img" src={project.img} alt={project.title + " image"} />
        </section>
    )
}

export default function Projects() {
    const data = [
        {
            title: "BookOpus App",
            techStack: "Flutter, Google Books API, Google Ads",
            description: [
                "Developed an app that fetches books from Google Books API, providing a centralized platform for book and e-book discovery.",
                "Created a user-friendly home screen displaying books categorized by genre, allowing for intuitive browsing.",
                "Implemented a versatile search feature enabling users to find books by title, author, and genre.",
                "Designed a book details page with comprehensive information and convenient purchase links.",
                "Incorporated non-intrusive banner ads to optimize revenue while maintaining a seamless user experience."
            ],
            links: {
                app: "",
                repo: "",
            },
            img: bookopus
        },
        {
            title: "Ashapura Hardware Website",
            techStack: "ReactJs, HTML, CSS, JavaScript, Firebase",
            description: [
                "Developed a responsive website for a home interior hardware business.",
                "Created a fully responsive website for optimal viewing on all devices.",
                "Deployed the website on Firebase web hosting for reliable hosting and delivery."
            ],
            links: {
                app: "",
                repo: "",
            },
            img: hardwareWebsite
        },
        {
            title: "Graph it!",
            techStack: "Flutter, Firebase",
            description: [
                "Developed a cross-platform app for plotting various types of graphs (line, bar, pie, multi-line) to cater to diverse data visualization needs.",
                "Enabled data upload via JSON/CSV files or manual entry, ensuring convenience and compatibility with multiple data sources.",
                "Stores graph to the local storage.",
                "Implemented secure local storage functionality to store and retrieve graphs, ensuring data persistence within the app.",
                "Integrated Google Authentication for streamlined and secure login process."
            ],
            links: {
                app: "",
                repo: "",
            },
            img: graphIt
        }
    ]

    return (
        <div className="projects">
            <img style={{ marginLeft: "min(35rem, 20vw)" }} className="projects-arrow" src={arrow3} alt="arrow" />
            <h2 className="projects-header">My Projects</h2>
            <img style={{ marginRight: "min(40rem, 25vw)" }} className="projects-arrow" src={arrow4} alt="arrow" />
            <Project
                key={0}
                project={data[0]}
                gradient={"linear-gradient(270deg, #FF4646 11.87%, #FF9486 100%)"}
                imgOnLeft={false}
            />
            <img className="projects-arrow" src={arrow5} alt="arrow" />
            <Project
                key={1}
                project={data[1]}
                gradient={"linear-gradient(270deg, #FEBD81 11.87%, #FFE598 55.02%, #BFF4A6 100%)"}
                imgOnLeft={true}
            />
            <img className="projects-arrow" src={arrow6} alt="arrow" />
            <Project
                key={2}
                project={data[2]}
                gradient={"linear-gradient(53.75deg, #81B3FE -31.62%, #E0A6F4 86.42%)"}
                imgOnLeft={false}
            />
        </div>
    )
}